import { createApp } from './main'
import { createHead } from '@unhead/vue'
import { SentryFactory } from '@/factories/SentryFactory'
import { bootstrapCapacitor } from '@/capacitorBootstrapper'
import type { App } from 'vue'
import type { Router } from 'vue-router'
import type { Pinia } from 'pinia'
import type { EventBus } from '@/events/EventBus'
import { usePageConfigurationStore } from '@/stores/ssr/usePageConfiguration'

// Create the app
createApp().then(
  async ({
           app,
           router,
           pinia,
           eventBus,
         }: {
    app: App
    router: Router
    pinia: Pinia
    eventBus: EventBus
  }) => {
    SentryFactory.create(app, router, __CAPACITOR__ ? 'capacitor' : 'csr')

    const clientHead = createHead()
    app.use(clientHead)

    if (__CAPACITOR__) {
      await bootstrapCapacitor(app, router, eventBus)
    }

    if (window.__INITIAL_STATE__) {

      pinia.state.value.ssr_establishment = window.__INITIAL_STATE__.ssr_establishment
      pinia.state.value.ssr_marketing_page = window.__INITIAL_STATE__.ssr_marketing_page
      pinia.state.value.ssr_marketplace = window.__INITIAL_STATE__.ssr_marketplace

      const store = usePageConfigurationStore()
      if (store.disableBranding === false && window.__INITIAL_STATE__.ssr_page_configuration) {
        store.disableBranding = window.__INITIAL_STATE__.ssr_page_configuration.disableBranding
      }
    }

    // Wait for the router to be ready (for async components or routes)
    router.isReady().then(() => {
      // Mount the app
      app.mount('#app')
    })
  },
)
